import React from 'react';
import { MenuItem, Tooltip, Checkbox, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles((theme) => ({
  level: {
    marginLeft: ({ hierarchyLevel }: { hierarchyLevel: number }) =>
      theme.spacing(hierarchyLevel),
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  item: {
    padding: 0,
    flexFlow: 'wrap',
    width: '100%'
  },
  checkBox: {
    margin: theme.spacing(0, 1, 0, 0),
    padding: theme.spacing(0),
    color: 'rgba(0, 0, 0, 0.36)',
    '&.Mui-checked': {
      color: theme.palette.grey[700]
    },
    '&.Mui-checked:hover': {
      color: theme.palette.grey[800]
    }
  },
  text: {
    color: theme.palette.text.primary
  }
}));

type HierarchyOptionItemProps = {
  hierarchyLevel?: number;
  title: string;
  selected: boolean;
};

export const SelectHierarchyOptionItem: React.FC<HierarchyOptionItemProps> = ({
  hierarchyLevel = 0,
  title,
  selected
}: HierarchyOptionItemProps) => {
  const classes = useStyles({ hierarchyLevel });

  return (
    <MenuItem component="div" className={classes.item}>
      <Tooltip title={title} disableInteractive>
        <div className={classes.level}>
          <Checkbox
            data-testid="setting-autocomplete-checkbox"
            checked={selected}
            className={classes.checkBox}
          />
          <Typography variant="inherit" noWrap className={classes.text}>
            {title}
          </Typography>
        </div>
      </Tooltip>
    </MenuItem>
  );
};

export default SelectHierarchyOptionItem;
